<template>
  <div id="accordion">
    <div class="card">
      <div class="card-header" id="headingAlert">
        <h5 class="mb-0">
          <button class="btn btn-link collapsed" v-bind:class="default_type === 'alert' ? 'show' : ''" data-toggle="collapse" data-target="#collapseAlert" aria-expanded="false" aria-controls="collapseAlert">
            Alert Extensions
          </button>
        </h5>
      </div>
      <div id="collapseAlert" class="collapse" v-bind:class="default_type === 'alert' ? 'show' : ''" aria-labelledby="headingAlert" data-parent="#accordion">
        <div class="card-body">
          <table class="table table-sm">
            <tbody>
              <tr v-for="alert in filtered_alerts" :key="alert.alert_id">
                <td class="d-none d-md-table-cell">{{ alert.name }}</td>
                <td>{{ alert.extension }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header" id="headingAnnouncement">
        <h5 class="mb-0">
          <button class="btn btn-link collapsed" v-bind:class="default_type === 'announcement' ? 'show' : ''" data-toggle="collapse" data-target="#collapseAnnouncement" aria-expanded="false" aria-controls="collapseAnnouncement">
            Announcement Extensions
          </button>
        </h5>
      </div>
      <div id="collapseAnnouncement" class="collapse" v-bind:class="default_type === 'announcement' ? 'show' : ''" aria-labelledby="headingAnnouncement" data-parent="#accordion">
        <div class="card-body">
          <table class="table table-sm">
            <tbody>
              <tr v-for="notification in filtered_notifications" :key="notification.notification_id">
                <td class="d-none d-md-table-cell">{{ notification.name }}</td>
                <td>{{ notification.extension }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header" id="headingDevice">
        <h5 class="mb-0">
          <button class="btn btn-link" v-bind:class="default_type != 'device' ? 'collapsed' : ''" data-toggle="collapse" data-target="#collapseDevice" aria-expanded="false" aria-controls="collapseDevice">
            Device Extensions
          </button>
        </h5>
      </div>
      <div id="collapseDevice" class="collapse" v-bind:class="default_type === 'device' ? 'show' : ''" aria-labelledby="headingDevice" data-parent="#accordion">
        <div class="card-body">
          <table class="table table-sm">
            <tbody>
              <tr v-for="device in filtered_devices" :key="device.device_id">
                <td class="d-none d-md-table-cell">{{ device.name }}</td>
                <td>{{ device.extension }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header" id="headingZone">
        <h5 class="mb-0">
          <button class="btn btn-link" v-bind:class="default_type != 'zone' ? 'collapsed' : ''" data-toggle="collapse" data-target="#collapseZone" aria-expanded="true" aria-controls="collapseZone">
            Zone Extensions
          </button>
        </h5>
      </div>
      <div id="collapseZone" class="collapse" v-bind:class="default_type === 'zone' ? 'show' : ''" aria-labelledby="headingZone" data-parent="#accordion">
        <div class="card-body">
          <table class="table table-sm">
            <tbody>
              <tr v-for="zone in filtered_zones" :key="zone.zone_id">
                <td class="d-none d-md-table-cell">{{ zone.name }}</td>
                <td>{{ zone.extension }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import { DEVICE_TYPE } from '../assets/js/resource-types'

export default {
  props: {
    default_type: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      alerts: 'allAlerts',
      devices: 'allDevices',
      notifications: 'allNotifications',
      scoped_site_id: 'scopedSiteId',
      zones: 'allZones'
    }),
    filtered_alerts: function () {
      return _.orderBy(this.alerts.filter(alert => alert.site_id === this.scoped_site_id && alert.extension !== 0), 'extension')
    },
    filtered_devices: function () {
      return _.orderBy(this.devices.filter(device => device.site_id === this.scoped_site_id && device.extension !== null && device.extension !== '' && device.extension !== 0), 'extension')
    },
    filtered_notifications: function () {
      return _.orderBy(this.notifications.filter(notification => notification.site_id === this.scoped_site_id && notification.extension !== 0), 'extension')
    },
    filtered_zones: function () {
      return _.orderBy(this.zones.filter(zone => zone.site_id === this.scoped_site_id && zone.extension !== '0'), 'extension')
    }
  },
  created () {
    this.$store.dispatch('getAlerts')
    this.$store.dispatch('getDevices')
    this.$store.dispatch('getNotifications')
    this.$store.dispatch('getZones')
  }
}
</script>
